<template>
  <div class="toolbar">
    <div
      class="tool-item f-jc-ac"
      v-for="item in toolList"
      :key="item.title"
      @click="handleClick(item.title)"
    >
      <div class="f-jc-ac">
        <img :src="item.img" alt="" />
        {{ item.title }}
      </div>
      <div v-if="item.title == '电话'" class="hover-phone">
        {{ site.consultHotline }}
      </div>
      <div v-if="item.title == '关注'" class="hover-code">
        <img :src="site.wechatLogo" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LayoutToolbar",
  props: {},
  data() {
    return {
      showTop: false,
    };
  },
  components: {},
  computed: {
    ...mapGetters(["site"]),
    toolList() {
      const arr = [
        {
          img: require("@/assets/images/home/tool-help.png"),
          title: "帮助",
        },
        {
          img: require("@/assets/images/home/tool-phone.png"),
          title: "电话",
        },
        {
          img: require("@/assets/images/home/tool-code.png"),
          title: "关注",
        },
      ];
      if (this.showTop) {
        arr.push({
          img: require("@/assets/images/home/tool-top.png"),
          title: "顶部",
        });
      }
      return arr;
    },
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      this.showTop = scrollTop > 200;
    },
    handleClick(val) {
      if (val == "顶部") {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }

      if (val == "帮助") {
        window.open("/info/list/bzzx");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.toolbar {
  position: fixed;
  bottom: 5%;
  right: 80px;
  width: 50px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.18);
  z-index: 9999;

  .tool-item {
    width: 100%;
    height: 60px;
    flex-direction: column;
    font-size: 12px;
    color: #999;
    position: relative;
    user-select: none;
    cursor: pointer;

    &:not(:last-of-type)::after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 25px;
      height: 1px;
      background: #cccccc;
    }

    > div {
      flex-direction: column;

      img {
        margin-bottom: 5px;
      }
    }

    .hover-phone,
    .hover-code {
      background: #0a569c;
      padding: 16px 24px;
      position: absolute;
      left: 0;
      transform: translateX(-100%);
      color: #fff;
      white-space: nowrap;
      display: none;

      img {
        width: 100px;
        max-width: 100px;
        height: 100px;
        margin-bottom: 0;
      }
    }

    &:hover {
      color: $--color-primary;

      .hover-phone,
      .hover-code {
        display: block;
      }
    }
  }
}
</style>
